export const getTableColumns = (handleProductModal, activeTab) => [
  {
    field: 'id',
    headerName: 'ID',
    width: 50,
  },
  {
    field: 'product_update_no',
    headerName: 'Product Update No.',
    width: 150,
    renderCell: (params) => (
      <a
        key={params.value}
        href="#"
        style={{ color: 'blue', textDecoration: 'none' }}
        onClick={(e) => {
          e.preventDefault();
          handleProductModal(params.row);
        }}
      >
        {params.value}
      </a>
    ),
  },
  {
    field: 'product_code',
    headerName: 'Product Code',
    width: 100,
  },
  {
    field: 'product_name',
    headerName: 'Product Name',
    width: 400,
  },
  {
    field: 'supplier_name',
    headerName: 'Supplier Name',
    width: 400,
  },
  {
    field: 'date_updated',
    headerName: 'Date Updated',
    width: 200,
  },
  {
    field: 'updated_by',
    headerName: 'Updated By',
    width: 200,
  },
  {
    field: 'approved_at',
    headerName: 'Date Approved',
    width: 200,
    hide: activeTab === 'appproved' ? false : true,
  },
  {
    field: 'declined_at',
    headerName: 'Date Declined',
    width: 200,
    hide: activeTab === 'declined' ? false : true,
  },
  {
    field: 'user_reviewer',
    headerName: activeTab === 'appproved' ? 'Approved By' : 'Declined By',
    width: 200,
    hide: activeTab === 'appproved' || activeTab === 'declined' ? false : true,
  },
];

export const styles = {
  border: {
    border: '1px solid #e7eaef',
  },
  divPadding: {
    padding: '5px',
  },
  fieldset: {
    border: '1px solid #e7eaef',
    padding: '-4px',
  },
  legend: {
    position: 'static',
    marginTop: '-20px',
    top: 1,
    fontSize: '13px',
    lineHeight: 1,
    margin: '-9px 0 0' /* half of font-size */,
    background: '#fff',
    color: '#000',
  },

  formGroup: {
    margin: 0,
    paddingTop: '0px',
    paddingLeft: '20px',
    paddingBottom: '0px',
    paddingRight: '0',
  },
};

export const tooltip = {
  title: 'Indicated in 2303 BIR Certificate of Registration',
  text: 'help_outline',
};

export const changesFieldLabel = {
  percent_down_payment: '% Down Payment',
  percent_intransit: '% In Transit',
  percent_upon_delivery: '% Upon Delivery',
  vat_exemption: 'Vat Exemption',
  cost: 'Cost Per Box',
  cost_vat: 'Cost Per Box (Vat Ex)',
  cost_unit: 'Cost Per Unit',
  cost_unit_vat: 'Cost Per Unit (Vat Ex)',
  selling_price: 'Selling Price Per Box',
  selling_price_vat: 'Selling Price Per Box (Vat Ex)',
  selling_price_unit: 'Selling Price Per Unit',
  selling_price_unit_vat: 'Selling Price Per Unit (Vat Ex)',
  percent_amount: 'Percent Amount',
  days_remaining: 'Days Remaining',
};
